import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import '../../Assets/Css/ViewClient.scss'
import UserAvatar from 'react-user-avatar';
import Table from '../../Components/Table';
import { Link } from 'react-router-dom';
import { HiOutlineMail } from 'react-icons/hi'
import { BiPhoneCall } from 'react-icons/bi'
import { getSingleClient } from '../../Services/Clients/action';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';
import { getShareholdersList } from '../../Services/Shareholders/action';
import { getCurrencyList, getSystemSettings } from '../../Services/Invoices/action';
import { getAllTransactions } from '../../Services/Transactions/action';


const ViewClient = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state.data;
    const [viewData, setViewData] = useState([]);
    const [dataInvoiceList, setDataInvoiceList] = useState([]);
    const [formattedData, setFormattedData] = useState([]);
    const [totalofoneinvoice, setTotalOfOneInvoice] = useState("");
    const [oneinvoicecurrencyINR, setOneInvoiceCurrencyINR] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [sumofallinvoice, setSumOfAllInvoice] = useState("");
    const [dueamount, setDueAmount] = useState("");
    const [currencyrate, setCurrencyRate] = useState("");
    const [receivedamount, setReceivedAmount] = useState("");
    const [debitedamount, setDebitedAmount] = useState("");
    const [defaultcurrencycode, setDefaultCurrencyCode] = useState("");
    const [defaultcurrencysymbol, setDefaultCurrencySymbol] = useState("");


    useEffect(() => {
        setIsLoading(true)
        props?.getCurrencyList();
        props?.getSystemSettings();
        props?.getAllTransactions(location.search);
        setIsLoading(false)
    }, [location.search]);

    useEffect(() => {
        if (data?.ClientId?.value) {
            props.getSingleClient(data?.ClientId?.value);
        } else {
            toast.error("Something Went Wrong !");
            navigate("/clients");
        }
    }, [data]);

    useEffect(() => {
        const fetchCurrencySettings = async () => {
            try {
                const DefaultCurrencyCode = await props?.systemsettings?.find((item) => item?.key)?.value;

                const DefaultCurrencySymbol = await props?.currencylist?.find((item) => item.code === DefaultCurrencyCode)?.symbol;


                setDefaultCurrencyCode(DefaultCurrencyCode);
                setDefaultCurrencySymbol(DefaultCurrencySymbol);
            } catch (error) {
                console.error("Error fetching systemsettings:", error);
            }
        }
        fetchCurrencySettings();
    }, [props?.systemsettings, props?.currencylist]);

    useEffect(() => {

        //any currency multiply wit its price
        const OneInvoiceCurrencyINR = viewData?.clientInvoices?.reduce((acc, item) => {
            const totalCurrencyINR = parseFloat(item.total) * parseFloat(item.currency_rate);
            acc?.push({ ...item, totalCurrencyINR });
            return acc;
        }, []);
        //sum of Currency in INR
        const SumoOfAllInvoice = OneInvoiceCurrencyINR?.reduce((acc, item) => {
            return acc + item.totalCurrencyINR;
        }, 0)
        //creditTransaction sum
        const creditTransaction = props?.transactionsList?.reduce((acc, item) => {
            const stringtonumber = Number(item?.amount)
            if (item?.type === "credit") {
                return acc + stringtonumber
            } else {
                return acc
            }
        }, 0)
        //DebitTransection sum
        const DebitTransection = props?.transactionsList?.reduce((acc, item) => {
            const stringtonumber = Number(item?.amount)
            if (item?.type === "debit") {
                return acc + stringtonumber
            } else {
                return acc
            }
        }, 0)

        //Find RecivedAmount
        setOneInvoiceCurrencyINR(OneInvoiceCurrencyINR);
        setSumOfAllInvoice(SumoOfAllInvoice);
        setReceivedAmount(creditTransaction);
        setDebitedAmount(DebitTransection);
        setDueAmount(SumoOfAllInvoice - creditTransaction);
    }, [viewData?.clientInvoices, props?.transactionsList])


    console.log(props?.systemsettings, defaultcurrencysymbol, defaultcurrencycode, props?.currencylist, props?.singleClient?.clientInvoices, "view cient");

    useEffect(() => {
        if (props?.singleClient) {
            setViewData(props?.singleClient);
            props?.singleClient?.clientInvoices && setDataInvoiceList(props?.singleClient?.clientInvoices?.map((item) => {

                const AmoutninINR = item.currency_rate * item.total

                //find currency code

                const DefaultCurrencyCode = props?.systemsettings?.find((item) => item?.key)?.value;

                const DefaultCurrencySymbol = props?.currencylist?.find((item) => item.code === DefaultCurrencyCode)?.symbol;

                const CurrencyCode = props?.currencylist.find((val) => val.id === item.currency_id)?.code

                const CurrencySymbol = props?.currencylist?.find((code) => code?.id === item.currency_id)?.symbol

                const RateofAllCurrency = CurrencyCode === DefaultCurrencyCode ?
                    "-"
                    :
                    `${CurrencySymbol || ""}${item?.total || 0}`;

                return {
                    'Invoice No': {
                        value: item.id,
                        type: 'text'
                    },
                    Date: {
                        value: moment(item.created_at).format("DD/MM/yyyy"),
                        type: 'date'
                    },
                    Title: {
                        value: item.title,
                        type: 'text'
                    },
                    "Amount(INR)": {
                        value: `${DefaultCurrencySymbol || ""}${AmoutninINR || 0}`,
                        type: 'text'
                    },
                    "Amount(~)": {
                        value: `${RateofAllCurrency}`,
                        type: 'text'
                    }

                }
            }))
            setFormattedData(
                {
                    Client: {
                        value: props.singleClient?.name || "unknown",
                        value2: props.singleClient?.email,
                        src: props.singleClient?.src,
                        type: 'client',
                    },
                    'Managed By': {
                        value: props.singleClient?.managedBy?.name || "unknown",
                        value2: props.singleClient?.managedBy?.email,
                        src: props.singleClient?.managedBy?.src,
                        type: 'client',
                    },
                    Address: {
                        value: props.singleClient?.address1,
                        value2: props.singleClient?.address2,
                        city: props.singleClient?.city,
                        state: props.singleClient?.state,
                        country: props.singleClient?.country,
                        postalcode: props.singleClient?.postalcode,
                        type: 'address'
                    },
                    Country: {
                        value: props.singleClient?.country,
                        type: 'text'
                    },
                    Mobile: {
                        value: props.singleClient?.mobile,
                        type: 'text'
                    },
                    Action: {
                        value: '/clients/edit',
                        value2: '/clients/view',
                        type: 'action'
                    },
                    ClientId: {
                        value: props.singleClient?.id
                    },
                    allData: {
                        ...props.singleClient
                    }
                });
        }

    }, [props.singleClient])

    const headerInvoiceList = [
        { field: 'Invoice No' },
        { field: 'Date' },
        { field: 'Title' },
        { field: 'Amount(INR)' },
        { field: 'Amount(~)' }
    ];

    return (
            <div className='viewClient-main'>
                <div className="page-title">
                    <h4>View Client</h4>
                    <div className="edit-btn">
                        <button type="button" disabled={props.loading} className="custom-btn">
                            <Link to='/clients/edit' style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: formattedData }}>
                                {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Edit"}
                            </Link>
                        </button>
                    </div>
                </div>
                {props.loading ? <div style={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                </div> :
                    <div className="content-part">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="left-part">
                                    <div className="left-top-part">
                                        <div className="client-image">
                                            <UserAvatar size='100' src={""} name={viewData?.name || "-"} />
                                        </div>
                                        <div className="client-details-content">
                                            <h6 className='label'>Name</h6>
                                            <h6 className='value'>{viewData?.name || "-"}</h6>
                                        </div>
                                        <div className="client-details-content">
                                            <h6 className='label'>Email</h6>
                                            <h6 className='value'>{viewData?.email || "-"}</h6>
                                        </div>
                                        <div className="client-details-content">
                                            <h6 className='label'>Mobile</h6>
                                            <h6 className='value'>{viewData?.mobile || "-"}</h6>
                                        </div>
                                        <div className="client-details-content">
                                            <h6 className='label'>Address</h6>
                                            <h6 className='value'>
                                                {viewData?.address1},{viewData?.address2},{viewData?.city},{viewData?.state},{viewData?.country} - {viewData?.postalcode}
                                            </h6>
                                        </div>
                                        <div className="client-details-content">
                                            <h6 className='label'>Notes</h6>
                                            <h6 className='value'>
                                                {viewData?.notes}
                                            </h6>
                                        </div>
                                        <div className="client-details-content">
                                            <h6 className='label'>Contact By</h6>
                                            <h6 className='value'>
                                                {viewData?.contact_by}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="left-bottom-part">
                                        <div className="image-div">
                                            <UserAvatar size='100' src={""} name={viewData?.managedBy?.name || "-"} />
                                        </div>
                                        <div className="details-content">
                                            <h6 className='label'>Name</h6>
                                            <h6 className='value'>{viewData?.managedBy?.name}</h6>
                                        </div>
                                        <div className="details-content">
                                            <h6 className='label'>Role</h6>
                                            <h6 className='value'>{viewData?.managedBy?.role?.name}</h6>
                                        </div>
                                        <div className="details-content">
                                            <h6 className='label'>Balance</h6>
                                            <h6 className='value'>{defaultcurrencysymbol || ""}{viewData?.managedBy?.balance || 0}</h6>
                                        </div>
                                        <div className="details-content">
                                            <h6 className='label'>{<BiPhoneCall />}</h6>
                                            <h6 className='value'>{viewData?.managedBy?.mobile}</h6>
                                        </div>
                                        <div className="details-content">
                                            <h6 className='label'>{<HiOutlineMail />}</h6>
                                            <h6 className='value'>{viewData?.managedBy?.email}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="right-part">
                                    <div className="tiles-first-row">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="tiles-container tiles-1">
                                                    <div className="text-content">
                                                        <h6 className='highlight-text'>Invoiced Amount</h6>
                                                        <div className='bottom-text'>
                                                            <h6 className='amount-text'>{defaultcurrencysymbol || ""}{sumofallinvoice || 0}</h6>
                                                            <span className='small-text'>Total amount of invoices</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="tiles-container tiles-2">
                                                    <div className="text-content">
                                                        <h6 className='highlight-text'>Received Amount</h6>
                                                        <div className='bottom-text'>
                                                            <h6 className='amount-text'>{defaultcurrencysymbol || ""}{receivedamount || 0}</h6>
                                                            <span className='small-text'>Total Amount Received</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="tiles-container tiles-3">
                                                    <div className="text-content">
                                                        <h6 className='highlight-text'>Due Amount</h6>
                                                        <div className='bottom-text'>
                                                            <h6 className='amount-text'>{defaultcurrencysymbol || ""}{dueamount || 0}</h6>
                                                            <span className='small-text'>Total Due</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="tiles-container tiles-3">
                                                    <div className="text-content">
                                                        <h6 className='highlight-text'>Debited Amount</h6>
                                                        <div className='bottom-text'>
                                                            <h6 className='amount-text'>{defaultcurrencysymbol || ""}{debitedamount || 0}</h6>
                                                            <span className='small-text'>Total Due</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="tiles-container tiles-4">
                                                    <div className="text-content">
                                                        <h6 className='highlight-text'>In Business since</h6>
                                                        <div className='bottom-text'>
                                                            <h6 className='amount-text'>{viewData?.financialSummary?.firstInvoiceDate.length > 0 ? moment(viewData?.financialSummary?.firstInvoiceDate[0]?.created_at).format("DD/MM/YYYY") : "Not Available"}</h6>
                                                            <span className='small-text'>Date of In Business since</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="tiles-container tiles-5">
                                                    <div className="text-content">
                                                        <h6 className='highlight-text'>Last Invoice</h6>
                                                        <div className='bottom-text'>
                                                            <h6 className='amount-text'>{viewData?.financialSummary?.lastInvoiceDate.length > 0 ? moment(viewData?.financialSummary?.lastInvoiceDate[0]?.created_at).format("DD/MM/YYYY") : "Not Available"}</h6>
                                                            <span className='small-text'>Date of Last Invoice</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="client-invoice-list">
                                        <h6 className='heading-title'>Invoice Lists</h6>
                                        <Table header={headerInvoiceList} data={dataInvoiceList} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.clientsReducer.loading,
        singleClient: state.clientsReducer.singleClient,
        shareholdersList: state.shareholdersReducer.shareholderslist,
        invoiceDetails: state.invoicesReducer.invoiceDetails,
        currencylist: state.invoicesReducer.currencylist,
        systemsettings: state.invoicesReducer.systemsettings,
        transactionsList: state.transactionReducers.transactions.rows,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getSingleClient: (id) => {
            dispatch(getSingleClient(id))
        },
        getShareholdersList: () => {
            dispatch(getShareholdersList());
        },
        getSingleInvoice: (id) => {
            dispatch(getSingleInvoice(id))
        },
        getCurrencyList: () => {
            dispatch(getCurrencyList());
        },
        getSystemSettings: () => {
            dispatch(getSystemSettings())
        },
        getAllTransactions: (params) => {
            dispatch(getAllTransactions(params))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewClient);
